import WishListService from "../Dashboard/wishListService";
import Tooltip from "../tooltip"

class RecentlyViewedProducts {
    constructor() {
        this.wishListService = new WishListService();
        this.getProducts();
    }

    getProducts () {
        let rvpId = this.getCookie('recentlyViewedProductsId');

        if (!rvpId) {
            return;
        }

        $.ajax({
            dataType: 'json',
            url: '/?action=index/rvp&id=' + rvpId,
            type: 'get',
            cache: false,
            success: function (response) {
                $('.rvpContainer').html(response.template);
                this.attachClickEvent();
                (new Tooltip).init();
            }.bind(this)
        })
    }

    getCookie(key) {
        let keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');

        return keyValue ? keyValue[2] : null;
    }

    attachClickEvent () {
        $(".rvpContainer button.addToWishlist").on('click', (event) => {
            this.wishListService.toggleWishList($(event.currentTarget));
        });
    }
}

$(document).ready(function () {
    new RecentlyViewedProducts();
});
